export function initSliderMaps($) {
  $('.slider-maps--slider-content').not('.slick-initialized').slick({
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    fade: true,
    // adaptiveHeight: true,
    asNavFor: '.slider-maps--slider-sync',
  });

  $('.slider-maps--slider-maps').not('.slick-initialized').slick({
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    asNavFor: '.slider-maps--slider-sync',
  });

  $('.slider-maps--slider-address').not('.slick-initialized').slick({
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    asNavFor: '.slider-maps--slider-sync',
  });

  function getAnchor() {
    return document.URL.split('#').length > 1 ? document.URL.split('#')[1] : null;
  }

  window.addEventListener('load', function () {
    var body = document.querySelector('body');
    if (body.classList.contains("page-id-1131")) {
      var sliderMapLinks = document.querySelectorAll(".slider-maps--link");
      var anchor = getAnchor();
      sliderMapLinks.forEach(function (item, index) {
        if (item.dataset.anchor == anchor) {
          var slideIndex = item.dataset.slide;
          $('.slider-maps--slider-content').slick('slickGoTo', slideIndex - 1);
        }
      });
    }
  });

  $('a[data-slide]').click(function () {
    var slideno = $(this).data('slide');
    $('.slider-maps--slider-content').slick('slickGoTo', slideno - 1);
  });
}

export function initMaps() {
  jQuery(window).on('load', function() {

  /* ========================================================================= *\
 **  === GOOGLE MAPS                                                          *| 
 \* ========================================================================= */
 // Google map
 if ($('.slider-maps--maps').length) {
   $('.slider-maps--maps').each(function() {
     var lat = parseFloat($(this).data("lat"));
     var lng = parseFloat($(this).data("lng"));
     var zoom = parseFloat($(this).data("zoom"));

     var map = new google.maps.Map($(this)[0], {
       center: new google.maps.LatLng(lat, lng),
       zoom: zoom,
       scrollwheel: false, // molette souris
       mapTypeControl: false, // boutton plan / satellite
       //mapTypeId: "hybrid", // Satelitte
       draggable: true, // draggable 
       zoomControl: true, // + - zoom
       //disableDefaultUI: true, // desactive tout
       styles: [{
         "featureType": "all",
         "elementType": "labels.text.fill",
         "stylers": [{
           "saturation": 36
         }, {
           "color": "#333333"
         }, {
           "lightness": 40
         }]
       }, {
         "featureType": "all",
         "elementType": "labels.text.stroke",
         "stylers": [{
           "visibility": "on"
         }, {
           "color": "#ffffff"
         }, {
           "lightness": 16
         }]
       }, {
         "featureType": "all",
         "elementType": "labels.icon",
         "stylers": [{
           "visibility": "off"
         }]
       }, {
         "featureType": "administrative",
         "elementType": "geometry.fill",
         "stylers": [{
           "color": "#fefefe"
         }, {
           "lightness": 20
         }]
       }, {
         "featureType": "administrative",
         "elementType": "geometry.stroke",
         "stylers": [{
           "color": "#fefefe"
         }, {
           "lightness": 17
         }, {
           "weight": 1.2
         }]
       }, {
         "featureType": "landscape",
         "elementType": "geometry",
         "stylers": [{
           "color": "#f5f5f5"
         }, {
           "lightness": 20
         }]
       }, {
         "featureType": "poi",
         "elementType": "geometry",
         "stylers": [{
           "color": "#f5f5f5"
         }, {
           "lightness": 21
         }]
       }, {
         "featureType": "poi.park",
         "elementType": "geometry",
         "stylers": [{
           "color": "#dedede"
         }, {
           "lightness": 21
         }]
       }, {
         "featureType": "road.highway",
         "elementType": "geometry.fill",
         "stylers": [{
           "color": "#f28e77"
         }, {
           "lightness": 17
         }]
       }, {
         "featureType": "road.highway",
         "elementType": "geometry.stroke",
         "stylers": [{
           "lightness": 29
         }, {
           "weight": 0.2
         }]
       }, {
         "featureType": "road.arterial",
         "elementType": "geometry",
         "stylers": [{
           "color": "#ffffff"
         }, {
           "lightness": 18
         }]
       }, {
         "featureType": "road.local",
         "elementType": "geometry",
         "stylers": [{
           "color": "#ffffff"
         }, {
           "lightness": 16
         }]
       }, {
         "featureType": "transit",
         "elementType": "geometry",
         "stylers": [{
           "color": "#f2f2f2"
         }, {
           "lightness": 19
         }]
       }, {
         "featureType": "water",
         "elementType": "geometry",
         "stylers": [{
           "color": "#e9e9e9"
         }, {
           "lightness": 17
         }]
       }]
   });

   var marker = new google.maps.Marker({
     map: map,
     position: {
       lat: lat,
       lng: lng
     }
   });
 });
}
  });
}
